export const adminInputClass = 'w-full rounded-xl border border-border px-4 py-2 text-sm'

export default function AdminFormField({ label, htmlFor, className = '', children }) {
  return (
    <div className={className}>
      <label htmlFor={htmlFor} className="mb-1.5 block text-xs font-medium text-text/70">
        {label}
      </label>
      {children}
    </div>
  )
}
